import React from 'react'
import classNames from 'classnames'
import s from './vertical-divider.scss'

export const VerticalDivider = ({className}: {className?: string}) => (
  <div className={classNames(className, s.verticalDivider)} />
)
